import React from "react";
import { Button } from "@mui/material";
import { useDispatch } from 'react-redux';
import { toast } from "react-toastify";
import _ from "lodash";
import toastMessages from "src/constant/toastMessages.json";
import IconLeftArrow from "src/assets/images/icon_left_arrow.svg";
import { EditDepotPersonal } from 'src/thunks/depotUsers';
import IconRemove from "src/assets/images/icon_remove.svg";
import { GetError } from "src/constant";
import { getAllNofificationForDashboard } from "src/thunks/dashboard";

export const RemoveProjectManager = ({ handleViewRecordButtonClick, selectedRemoveProjectInfo, setRemoveProjectModel, selectedData }) => {

    /** redux store useDispatch & useSelector ------------------------------ **/
    const dispatch = useDispatch()

    /** handler functions--------------------------------------------------- **/
    const handleRemoveProjectModelClose = () => {
        setRemoveProjectModel(false);
    };

    /** Function to remove a project ----------------- **/
    const handleRemoveProjectClick = async () => {
        const oldProjectsArray = _.filter(selectedData?.projects, (d1) => d1.id !== selectedRemoveProjectInfo?.id)
        try {
            let ModelData = {
                "firstName": selectedData?.firstName,
                "lastName": selectedData?.lastName,
                "middleName": selectedData?.middleName || "",
                "role": "ProjectManager",
                "email": selectedData?.email,
                "username": selectedData?.email,
                "address": {
                    "street1": "",
                    "country": "",
                    "city": "",
                    "zip": "",
                },
                "phoneNumber": selectedData?.phoneNumber,
                "profileUrl": selectedData?.profileUrl,
                "projects": _.map(oldProjectsArray, (d) => ({
                    id: d?.id,
                    name: d?.name
                })
                )
            };
            ModelData = {
                data: ModelData,
                id: selectedData?.id,
                "isParentResourceUpdated": false,
                "isProjectManager": true,
                "removeProject": true,
                "removeProjectData": _.find(selectedData?.projects, (d1) => d1.id === selectedRemoveProjectInfo?.id)
            };
            let result = await dispatch(EditDepotPersonal(ModelData)).unwrap();
            if (result) {
                setTimeout(() => {
                    dispatch(getAllNofificationForDashboard(1, 20));
                }, 2000);
                setRemoveProjectModel(false);
                toast.success(toastMessages.projectRemoved)
                handleViewRecordButtonClick();
            }
        }
        catch (err) {
            toast.error(GetError(err?.response?.data?.errors) || "something issue");
        }
    }

    return (
        <>
            <div>
                <div className="depot-form-header-style">
                    <span className="allocate-mgnr-header-color me-2">REMOVE PROJECT</span>
                    <span className="allocate-mgnr-subheader-color">{selectedRemoveProjectInfo?.name} / {selectedData?.firstName || ""} {selectedData?.lastName || ""}</span>

                </div>
                <div style={{ paddingLeft: 100, paddingRight: 100 }} >
                    <div className="d-flex flex-column" style={{ marginTop: 100 }}>
                        <span className="depotManagerName-style common-text-for-removeDepotManager">{selectedRemoveProjectInfo?.name}</span>
                        <span className="removeDepotManager-text-removed common-text-for-removeDepotManager mb-3">project will be removed.</span>
                    </div>
                    <div className="d-flex flex-column" style={{ marginTop: 100 }}>
                        <span className="mb-3 confirm-msg-for-removeDepotManager">Are you sure you want to proceed?</span>
                        <div className="d-flex flex-row">
                            <Button variant="outlined" className="btn-bootstrap-submit-style" startIcon={<img src={IconLeftArrow} width={15} height={15} alt="new"></img>} onClick={handleRemoveProjectModelClose} type="submit"
                            >
                                No, Go Back
                            </Button>

                            <Button variant="outlined" className="btn-bootstrap-submit-style ms-3" style={{ color: "red", borderColor: "red" }} onClick={handleRemoveProjectClick} startIcon={<img src={IconRemove} width={15} height={15} alt="new"></img>}
                            >
                                Yes, Remove Project
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}